import { render, staticRenderFns } from "./add-paper-from-query.html?vue&type=template&id=1cb4fde0&scoped=true&external"
import script from "./add-paper-from-query.js?vue&type=script&lang=js&external"
export * from "./add-paper-from-query.js?vue&type=script&lang=js&external"
import style0 from "./add-paper-from-query.scss?vue&type=style&index=0&id=1cb4fde0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb4fde0",
  null
  
)

export default component.exports